import React, { lazy, Suspense } from "react";
// SQUIDDI-seo - 2026-10-17 · il footer sta sotto la piega: arriva a parte.
const Footer = lazy(() => import("@/components/Footer"));

/* iter413 · Il blocco di fondo sta nel flusso normale della pagina: niente
   `position: fixed`, niente misure in JavaScript. L'area del contenuto riserva
   almeno un'altezza schermo, così mentre una pagina carica il footer resta
   sotto la piega e non può più comparire a metà. */
export default function RevealFooter({ children }) {
  return (
    <div className="flex flex-1 flex-col" data-testid="reveal-footer-wrap">
      <div className="flex flex-1 flex-col min-h-[calc(100dvh-64px)]">{children}</div>
      <div data-testid="reveal-footer">
        <Suspense fallback={<div className="min-h-[320px] bg-[#0B0814]" aria-hidden="true" />}>
          <Footer />
        </Suspense>
      </div>
    </div>
  );
}
